import '../style/switch-CM5PWtg1.css'
import { defineComponent as A, toRefs as O, computed as f, ref as D, openBlock as r, createBlock as h, unref as s, normalizeStyle as v, createElementBlock as y, normalizeClass as M, createElementVNode as c, normalizeProps as U, mergeProps as F, createCommentVNode as k, renderSlot as G } from "vue";
import { isPromise as w } from "@vue/shared";
import { useComponentClassList as H } from "./hooks/useComponentClassList.js";
import { useFormItem as R } from "./hooks/useFormItem.js";
import Z from "./spinner.js";
import W from "./icon-button.js";
import j from "./skeleton.js";
import { SWITCH_SIZE_CONFIGURATION as q } from "./constant/switch.js";
import { UPDATE_MODEL_VALUE as p, CHANGE_EVENT as b } from "./constant/events.js";
import { useInputSize as x } from "./hooks/useInputSize.js";
import { DEFAULT_SIZE as J } from "./constant/common.js";
const K = ["for"], Q = { class: "e-switch__wrap" }, X = ["id", "aria-label", "checked", "aria-checked", "name", "disabled", "aria-disabled"], Y = { class: "e-switch__handle" }, ee = /* @__PURE__ */ c("div", { class: "e-switch__background" }, null, -1), oe = {
  key: 0,
  class: "e-switch__content"
}, I = "e-switch", he = /* @__PURE__ */ A({
  name: I,
  __name: "switch",
  props: {
    modelValue: { type: Boolean },
    loading: { type: Boolean, default: !1 },
    name: {},
    disabled: { type: Boolean },
    reversed: { type: Boolean },
    colorScheme: {},
    size: { default: J },
    withIcon: { type: Boolean },
    overrides: {},
    delay: {},
    beforeChange: {}
  },
  emits: [p, b],
  setup(C, { emit: E }) {
    const o = C, d = E, { formItem: m, formSize: S } = R(), { size: V, disabled: u, colorScheme: g } = O(o), { actualSize: _ } = x({ formSize: S, propSize: V }), z = H(I, {
      size: _,
      disabled: u,
      colorScheme: g
    }), N = f(() => {
      const e = [...z.value];
      return o.reversed && e.push("e-switch--reversed"), e;
    }), B = f(() => {
      const { overrides: e = {} } = o, t = q[_.value], n = e["--switch-width"] ?? `${t[0]}px`, l = e["--switch-height"] ?? `${t[1]}px`;
      return {
        width: n,
        height: l
      };
    }), a = D(!1), T = f(() => {
      const { overrides: e = {} } = o;
      let t;
      return e.activeIcon || e.inactiveIcon ? t = o.modelValue ? e.activeIcon : e.inactiveIcon : t = o.modelValue ? "checkmark" : "cross", {
        icon: t,
        hideSkeleton: !0,
        size: "sm",
        color: o.modelValue ? "var(--switch-active-icon-color)" : "var(--switch-icon-color)"
      };
    });
    function P(e) {
      return typeof e == "boolean";
    }
    async function L(e) {
      const { modelValue: t, beforeChange: n } = o, l = !t;
      if (n) {
        if (e.preventDefault(), a.value) return;
        const i = n();
        if (!(w(i) || P(i))) {
          console.error("[e-switch]beforeChange must return type `Promise<boolean>` or `boolean`");
          return;
        }
        if (w(i))
          a.value = !0, i.then(($) => {
            $ && d(p, l);
          }).finally(() => {
            a.value = !1;
          });
        else if (!i)
          return;
      }
      o.delay && (a.value = !0, await new Promise((i) => setTimeout(i, o.delay)), a.value = !1), d(p, l), d(b, l);
    }
    return (e, t) => e.loading ? (r(), h(s(j), {
      key: 0,
      style: v(B.value),
      "border-radius": "16px"
    }, null, 8, ["style"])) : (r(), y("label", {
      key: 1,
      for: s(m).formItemId,
      class: M(N.value),
      style: v(e.overrides)
    }, [
      c("span", Q, [
        c("input", {
          id: s(m).formItemId,
          "aria-label": s(m).label,
          checked: e.modelValue,
          "aria-checked": e.modelValue,
          type: "checkbox",
          role: "switch",
          class: "e-switch__check",
          name: e.name,
          disabled: s(u),
          "aria-disabled": s(u),
          onClick: L
        }, null, 8, X),
        c("div", Y, [
          a.value ? (r(), h(s(Z), { key: 0 })) : e.withIcon ? (r(), h(s(W), U(F({ key: 1 }, T.value)), null, 16)) : k("", !0)
        ]),
        ee
      ]),
      e.$slots.default ? (r(), y("div", oe, [
        G(e.$slots, "default")
      ])) : k("", !0)
    ], 14, K));
  }
});
export {
  he as default
};
//# sourceMappingURL=switch.js.map
